import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Grid, Table } from "semantic-ui-react";
import { Heading2 } from "../../components/value-cssmodules/TextComponent";
import { orderListSelector, userIsAdminSelector } from "../../utils/selectors";
import isEmpty from "../../validation/is-empty";
import styles from "./OrdersListAdmin.module.scss";
import OrdersListRow from "./OrdersListRow";
import { listAllOrders } from "../../actions/orderActions";
import { Order } from "../../types/orderTypes";
import Spinner from "../../components/Spinner";
import CustomPagination from "../../components/Pagination/CustumPagination";

const PatternListAdmin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { orders, loading } = useSelector((state) => orderListSelector(state));
  const admin = useSelector((state) => userIsAdminSelector(state));
  const [page, setPage] = useState<number>(1)

  useEffect(() => {
    if (!admin) {
      navigate("/admin");
    }
  }, [dispatch, navigate, admin]);

  useEffect(() => {
    const pageLimit = 10
    dispatch(listAllOrders(page, pageLimit));
  }, [dispatch, page]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <Grid className={styles.self}>
      <Container>
        <Grid.Row>
          <Grid.Column width={8}>
            <Heading2>
              <FormattedMessage id="admin.orderList.title" />
            </Heading2>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          {" "}
          <Table striped size="small">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  <FormattedMessage id={"admin.list.titleId"} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <FormattedMessage id={"admin.list.isPaid"} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <FormattedMessage id="cart.tableTitle.totalPrice" />
                </Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!isEmpty(orders) &&
                orders.orders.map((order: Order) => {
                  return (
                    <OrdersListRow
                      order={order}
                      key={order._id}
                    />
                  );
                })}
            </Table.Body>
          </Table>
        </Grid.Row>
          <CustomPagination 
         page={page}
          totalPages={orders?.totalPage}
          onPageChange={(p) => setPage(p)}/>
      </Container>
    </Grid>
  );
};

export default PatternListAdmin;
